import { Signal } from '@preact/signals-react'

// Utility type per estrarre il tipo di valore da un Signal
type Unwrap<T> = T extends Signal<infer U> ? U : T

// Funzione di utility per il merge sicuro dei signals
export function mergeSignal<T extends Signal<any>>(
  signalObj: T,
  newValue: Partial<Unwrap<T>>
): void {
  signalObj.value = {
    ...signalObj.value,
    ...newValue,
  } as Unwrap<T>
}
